import { DataProvider } from "../helpers"
import { OpRelatedObjects } from "../models/custom/op-related-objects"

export class DataProviderArticle {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion

    // #region Get

    public getArticlesBySerialNumbers = (serialNbrs: number[]): JQueryPromise<OpRelatedObjects[]> => {
        return this.dataProvider.sendRequestWithSession('OpxGetArticleBySerialNbrs', { serialNbrs: serialNbrs }, 'OpxGetArticleBySerialNbrsResult')
            .then((response: any[]) => {
                if (response != null) {
                    return response.map((e: any) => new OpRelatedObjects(e))
                }
                return null
            })
    }

    // #endregion
}